module.exports = __webpack_public_path__ + "img/markerMetroBlue.4c6e5930.svg";